<template>
    <div>
        <a-tabs v-bind:default-active-key="selectedFamilyMemberId" type="card" @change="familyMemberSelected">
            <a-tab-pane v-for="member in family" :key="member.id">
                <template slot="tab">
                    <CustomerBadgeComponent v-bind:customer="member"
                                            v-bind:link="false"
                                            size="small"
                                            v-bind:tooltip="false">
                    </CustomerBadgeComponent>
                </template>
                <CustomerPropertyIndexPanelComponent v-bind:customer="member">
                </CustomerPropertyIndexPanelComponent>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>

<script>
import CustomerPropertyRowComponent from './RowComponent'
import CustomerPropertyIndexPanelComponent from './IndexPanelComponent'
import CustomerBadgeComponent from "../../customer/components/BadgeComponent";

export default {
  name: "AddressIndexComponent",
  components: {
    CustomerPropertyRowComponent,
    CustomerBadgeComponent,
    CustomerPropertyIndexPanelComponent
  },
  props: {
    family: {
      required: true,
    },
    customerProperties: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      selectedFamilyMemberId: this.family[0].id,
      selectedCustomerProperties: {},
      addressTypes: {
        'visit': 'Bezoekadressen',
        'mail': 'Postadressen',
        'establishment': 'Vestiginsadressen',
        'unknown': ' Onbekende adrestypes'
      },
      items: [
        {
          type: 'primary',
          icon: 'plus',
          link: '/customer/' + this.selectedFamilyMemberId + '/property/create',
          name: 'Adres toevoegen',
        },
      ],
    };
  },
  computed: {
    selectedCustomerPropertiesExists() {
      return this.selectedCustomerProperties !== null;
    },
  },
  mounted() {
    this.selectedCustomerProperties = this.customerProperties[this.selectedFamilyMemberId]
  },
  methods: {
    changeSelectedCustomerProperties(selectedMemberId) {
      this.selectedCustomerProperties = this.customerProperties[selectedMemberId]

    },
    familyMemberSelected(key) {
      this.selectedFamilyMemberId = key
      this.changeSelectedCustomerProperties(key)
    },
    customerShortName(customer) {
      let shortName = '';

      if (customer.initials !== null && customer.initials.length > 0) {
        shortName += customer.initials;
      } else if (customer.first_name) {
        shortName += customer.first_name;
      } else {
        shortName += customer.firstName;
      }

      if (customer.suffix !== null && customer.suffix.length > 0) {
        shortName += ' ' + customer.suffix;
      }

      if (customer.last_name) {
        shortName += ' ' + customer.last_name;
      } else {
        shortName += ' ' + customer.lastName;

      }

      //TODO:: add age

      return shortName;
    },
    hasCustomerProperties(customerProperties) {
      return customerProperties.length > 0;
    },

    translateKey(key) {
      return this.addressTypes[key]
    },
    getIconByKey(key) {
      // TODO: make cleaner
      if (key === 'mail') {
        return '<i class="mdi mdi-mail"></i>'
      }
      if (key === 'unknown') {
        return '<i class="mdi mdi-comment-question"></i>'
      }
      return '<i class="mdi mdi-home"></i>'
    },
    handleToCreate() {
      window.location = '/customer/' + this.selectedFamilyMemberId + '/property/create';
    },
    getCustomerAvatarUrl(customer) {
      return '/customer/' + customer.id + '/avatar'
    }
  }
}
</script>
<style scoped>
.padding-top-20 {
    padding-top: 20px;
}

.avatar {
    height: 20px;
    width: 20px;
    vertical-align: middle;
    margin-top: -2px;
}
</style>
